/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_A3Inputs */

const en_to_xml_faq_a3 = /** @type {(inputs: To_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Characters that XML does not allow in a name are replaced with underscores. A name that would begin with a digit or a hyphen also gets an underscore prefix, so the key 2nd becomes the element _2nd rather than invalid markup.`)
};

const ko_to_xml_faq_a3 = /** @type {(inputs: To_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML이 이름에 허용하지 않는 문자는 밑줄로 치환됩니다. 숫자나 하이픈으로 시작하게 될 이름에는 밑줄 접두사도 붙으므로, 키 2nd는 유효하지 않은 마크업이 아니라 요소 _2nd가 됩니다.`)
};

const ja_to_xml_faq_a3 = /** @type {(inputs: To_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML が名前に許さない文字はアンダースコアに置換されます。数字やハイフンで始まることになる名前にもアンダースコアの接頭辞が付くので、キー 2nd は妥当でないマークアップではなく要素 _2nd になります。`)
};

/**
* | output |
* | --- |
* | "Characters that XML does not allow in a name are replaced with underscores. A name that would begin with a digit or a hyphen also gets an underscore prefix, ..." |
*
* @param {To_Xml_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_a3 = /** @type {((inputs?: To_Xml_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_a3(inputs)
	if (locale === "ko") return ko_to_xml_faq_a3(inputs)
	return ja_to_xml_faq_a3(inputs)
});